function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var detailSelect = /*#__PURE__*/function () {
  function detailSelect(container) {
    _classCallCheck(this, detailSelect);

    this.container = document.querySelector(container);
    this.options = document.querySelectorAll("".concat(container, " > .select > .select__option"));
    this.value = this.container.querySelector('summary').textContent;
    this.mouseDown = false;

    this._addEventListeners();

    this._setAria();

    this.updateValue();
  } // Private function to set event listeners


  _createClass(detailSelect, [{
    key: "_addEventListeners",
    value: function _addEventListeners() {
      var _this = this;

      this.container.addEventListener('toggle', function () {
        if (_this.container.open) return;

        _this.updateValue();
      });
      this.container.addEventListener('click', function () {
        if (_this.container.open) return;

        _this.updateValue();
      });
      this.container.addEventListener('focusout', function (e) {
        if (_this.mouseDown) return;

        _this.container.removeAttribute('open');
      });
      this.options.forEach(function (opt) {
        opt.addEventListener('mousedown', function () {
          _this.mouseDown = true;
        });
        opt.addEventListener('mouseup', function () {
          _this.mouseDown = false;

          _this.container.removeAttribute('open');
        });
      });
      this.container.addEventListener('keyup', function (e) {
        var keycode = e.which;

        var current = _toConsumableArray(_this.options).indexOf(_this.container.querySelector('.active'));

        switch (keycode) {
          case 27:
            // ESC
            _this.container.removeAttribute('open');

            break;

          case 35:
            // END
            e.preventDefault();
            if (!_this.container.open) _this.container.setAttribute('open', '');

            _this.setChecked(_this.options[_this.options.length - 1].querySelector('input'));

            break;

          case 36:
            // HOME
            e.preventDefault();
            if (!_this.container.open) _this.container.setAttribute('open', '');

            _this.setChecked(_this.options[0].querySelector('input'));

            break;

          case 38:
            // UP
            e.preventDefault();
            if (!_this.container.open) _this.container.setAttribute('open', '');

            _this.setChecked(_this.options[current > 0 ? current - 1 : 0].querySelector('input'));

            break;

          case 40:
            // DOWN
            e.preventDefault();
            if (!_this.container.open) _this.container.setAttribute('open', '');

            _this.setChecked(_this.options[current < _this.options.length - 1 ? current + 1 : _this.options.length - 1].querySelector('input'));

            break;
        }
      });
    }
  }, {
    key: "_setAria",
    value: function _setAria() {
      this.container.setAttribute('aria-haspopup', 'listbox');
      this.container.querySelector('.select').setAttribute('role', 'listbox');
      var summary = this.container.querySelector('summary');
      summary.setAttribute('aria-label', "unselected listbox");
      summary.setAttribute('aria-live', "polite");
      this.options.forEach(function (opt) {
        opt.setAttribute('role', 'option');
      });
    }
  }, {
    key: "updateValue",
    value: function updateValue(e) {
      var that = this.container.querySelector('input:checked');
      if (!that) return;
      this.setValue(that);
    }
  }, {
    key: "setChecked",
    value: function setChecked(that) {
      that.checked = true;
      this.setValue(that);
    }
  }, {
    key: "setValue",
    value: function setValue(that) {
      if (this.value == that.value) return;
      var summary = this.container.querySelector('summary');
      var pos = _toConsumableArray(this.options).indexOf(that.parentNode) + 1;
      summary.textContent = that.parentNode.textContent;
      summary.setAttribute('aria-label', "".concat(that.value, ", listbox ").concat(pos, " of ").concat(this.options.length));
      this.value = that.value;
      this.options.forEach(function (opt) {
        opt.classList.remove('active');
        opt.setAttribute('aria-selected', 'false');
      });
      that.parentNode.classList.add('active');
      that.parentNode.setAttribute('aria-selected', 'true');
      this.container.dispatchEvent(new Event('change'));
    }
  }]);

  return detailSelect;
}();